import NietErnstigeBloedingenOnderTar from "../../../../src/client/lta-antistolling/niet-ernstige-bloedingen-onder-tar.json";
import * as React from 'react';
export default {
  NietErnstigeBloedingenOnderTar,
  React
};